import { useCheckoutMessage } from '@/scopes/checkout/domain/hooks'
import { Banner, type BannerType, SpaceBetween, tk, Typography } from '@sunwebgroup/ui-components'
import * as React from 'react'
import { styled } from 'styled-components'

const Texts = styled(SpaceBetween)`
  flex: 1;
`
export function CheckoutMessage(props: { componentId: string }) {
  const { componentId } = props
  const { message } = useCheckoutMessage(componentId)

  if (!message)
    return null

  const { banners } = message
  if (!banners.length) {
    return null
  }

  return (
    <SpaceBetween direction="y" spacing={tk('spacing_md')}>
      {banners.map(
        ({ title, text, type = 'info' }: { title?: string, text?: string, type?: string }, index: number) => (
          <Banner key={`banner-${index}`} $type={type as BannerType}>
            <Texts direction="y">
              {title && <Typography $variant="label">{title}</Typography>}
              {text && <Typography dangerouslySetInnerHTML={{ __html: text }} />}
            </Texts>
          </Banner>
        ),
      )}
    </SpaceBetween>
  )
}
